import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation RequestLoginWhenExpiredMutation($input: RequestLoginWhenExpiredInput!) {
    requestLoginWhenExpired(input: $input) {
      status
    }
  }
`;

function commit(environment, token, language, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        token,
        language
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.requestLoginWhenExpired.status);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
